import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { PostItem } from '@apps/api-interfaces';

export interface PostState extends EntityState<PostItem> {
  isLoading: boolean;
  error: any;
}

export const invoicesAdapter: EntityAdapter<PostItem> = createEntityAdapter<
  PostItem
>({
  selectId: (e: PostItem) => e.slug,
  sortComparer: false
});

export const invoicesInitialState: PostState = invoicesAdapter.getInitialState({
  isLoading: true,
  error: null
});

export const selectIsLoading = (state: PostState) => state.isLoading;
export const selectError = (state: PostState) => state.error;
